export default (node) => {
  const sortBy = node.querySelector('[data-sort-by]');
  const descContainer = document.querySelector('[data-collection-desc]');
  const btnTextDescription = document.querySelector('[data-desc-btn-text]');

  const readToggle = document.querySelector('[data-read-toggle]');
  const btnText = readToggle
    ? readToggle.querySelector('[data-btn-text]')
    : null;
  const seoDescription = document.querySelector('[data-seo-description]');
  const readMoreText = readToggle
    ? readToggle.dataset.readToggleReadMore
    : null;
  const readLessText = readToggle
    ? readToggle.dataset.readToggleReadLess
    : null;
  const maxHeight = 245;

  const descToggle = document.querySelector('[data-desc-toggle]');
  const descToggleReadMore = descToggle
    ? descToggle.dataset.descToggleReadMore
    : 'Read More';
  const descToggleReadLess = descToggle
    ? descToggle.dataset.descToggleReadLess
    : 'Read Less';

  const applySort = (e) => {
    e.preventDefault();
    const sortValue = e.currentTarget.value;
    // check if the url has sort_by parameter, if exits replace it with the new value else add it
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set('sort_by', sortValue);
    // modify the url with the new search params without reloading the page
    const urlToCall = `${url.origin}${url.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, '', urlToCall);
    window.location.href = urlToCall;
  };

  const toggleReadMore = (e) => {
    e.preventDefault();
    if (seoDescription.classList.contains('h-auto')) {
      seoDescription.classList.remove('h-auto');
      btnText.textContent = readMoreText;
    } else {
      seoDescription.classList.add('h-auto');
      btnText.textContent = readLessText;
    }

    const seoDescriptionInner = seoDescription.querySelector('.seo_inner_desc');
    if (readToggle) {
      if (seoDescriptionInner.offsetHeight < maxHeight) {
        readToggle.classList.add('hidden');
      } else {
        readToggle.classList.remove('hidden');
      }
    }
  };

  const toggleDesc = (e) => {
    e.preventDefault();
    if (!descContainer.classList.contains('line-clamp-2')) {
      descContainer.classList.add('line-clamp-2');
      descContainer.classList.remove('h-full');
      if (btnTextDescription) {
        btnTextDescription.textContent = descToggleReadMore;
      }
      descContainer.classList.add('bottom-gradient');
    } else {
      descContainer.classList.remove('bottom-gradient');
      descContainer.classList.remove('line-clamp-2');
      descContainer.classList.add('h-full');
      if (btnTextDescription) {
        btnTextDescription.textContent = descToggleReadLess;
      }
    }
  };

  const init = () => {
    if (sortBy) {
      sortBy.addEventListener('change', applySort);
    }
    if (readToggle) {
      readToggle.addEventListener('click', toggleReadMore);
    }

    if (descToggle && btnTextDescription) {
      descToggle.addEventListener('click', toggleDesc);

      const descHeight = descContainer.offsetHeight;
      if (descHeight < 30) {
        descToggle.classList.add('hidden');
      } else {
        descContainer.classList.add('bottom-gradient');
      }
    }
  };

  init();
};
